import React, { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { AuthShell } from './AuthShell';
import { Button, TextButton, Field, Input } from './ui';

interface LoginProps {
  onToggleMode: () => void;
  onForgotPassword: () => void;
}

export const Login: React.FC<LoginProps> = ({ onToggleMode, onForgotPassword }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const { login } = useAuth();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    try {
      await login(email, password);
    } catch (err: any) {
      setError(err.message || 'Login failed');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthShell
      title="Sign in"
      subhead="Your income, expenses, cards and projections."
      error={error}
      footer={
        <p className="text-[13.5px] text-ink-soft">
          Don't have an account?{' '}
          <button
            type="button"
            onClick={onToggleMode}
            className="text-accent hover:text-accent-press transition-colors duration-[120ms]"
          >
            Sign up
          </button>
        </p>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-6">
        <Field label="Email" htmlFor="login-email">
          <Input
            id="login-email"
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your.email@example.com"
          />
        </Field>

        <Field label="Password" htmlFor="login-password">
          <Input
            id="login-password"
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Your password"
          />
        </Field>

        <div className="flex items-center justify-between gap-4 pt-1">
          <TextButton type="button" onClick={onForgotPassword}>
            Forgot password?
          </TextButton>
          <Button type="submit" variant="primary" disabled={isLoading}>
            {isLoading ? 'Signing in…' : 'Sign in'}
          </Button>
        </div>
      </form>
    </AuthShell>
  );
};
